import { mapIntegrationProviderFromDTO } from '@/modules/common/mappers';
import { IntegrationProviderDTO } from '@/modules/common/types/dto/response/integration-response';

import { BillSyncError, BillSyncErrorReason, BillSyncOperation } from '../types/bills';
import { BillSyncErrorReasonDTO, BillSyncOperationDTO } from '../types/dto';
import { SyncErrorResponse } from '../types/dto/response';

export const mapBillSyncOperationFromDTO = (
  operation: BillSyncOperationDTO | null | undefined
): BillSyncOperation | null => {
  switch (operation) {
    case BillSyncOperationDTO.CREATE:
      return BillSyncOperation.Create;
    case BillSyncOperationDTO.UPDATE:
      return BillSyncOperation.Update;
    default:
      return null;
  }
};

const mapBillSyncErrorReasonFromDTO = (
  reason: BillSyncErrorReasonDTO | null | undefined
): BillSyncErrorReason | null => {
  switch (reason) {
    case BillSyncErrorReasonDTO.VENDOR_NOT_AVAILABLE:
      return BillSyncErrorReason.VendorNotAvailable;
    case BillSyncErrorReasonDTO.PROJECT_NOT_AVAILABLE:
      return BillSyncErrorReason.ProjectNotAvailable;
    case BillSyncErrorReasonDTO.PRODUCT_OR_SERVICE_NOT_AVAILABLE:
      return BillSyncErrorReason.ProductOrServiceNotAvailable;
    case BillSyncErrorReasonDTO.VENDOR_CURRENCY_MISMATCH:
      return BillSyncErrorReason.VendorCurrencyMismatch;
    case BillSyncErrorReasonDTO.CURRENCY_NOT_ENABLED:
      return BillSyncErrorReason.CurrencyNotEnabled;
    case BillSyncErrorReasonDTO.ACCOUNTING_PERIOD_CLOSED:
      return BillSyncErrorReason.AccountingPeriodClosed;
    case BillSyncErrorReasonDTO.NEGATIVE_LINE_AMOUNT_NOT_ALLOWED:
      return BillSyncErrorReason.NegativeLineAmountNotAllowed;
    case BillSyncErrorReasonDTO.LINE_DESCRIPTION_TOO_LONG:
      return BillSyncErrorReason.LineDescriptionTooLong;
    case BillSyncErrorReasonDTO.TRANSACTION_DATE_NOT_ALLOWED:
      return BillSyncErrorReason.TransactionDateNotAllowed;
    case BillSyncErrorReasonDTO.LINE_VALUE_OUT_OF_RANGE:
      return BillSyncErrorReason.LineValueOutOfRange;
    case BillSyncErrorReasonDTO.DATA_REJECTED:
      return BillSyncErrorReason.DataRejected;
    default:
      return null;
  }
};

export const mapBillSyncErrorFromResponse = (
  response: SyncErrorResponse | null | undefined
): BillSyncError | null => {
  if (!response) return null;

  return {
    code: response.code,
    message: response.message,
    provider:
      response.provider && response.provider !== IntegrationProviderDTO.UNKNOWN
        ? mapIntegrationProviderFromDTO(response.provider)
        : null,
    details: response.details ?? null,
    reason: mapBillSyncErrorReasonFromDTO(response.reason),
  };
};
